// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"93d98e28","123":"748e6d9b","283":"0c7dbca8","347":"1fe2bb71","354":"25b7cc76","389":"81fd912f","453":"e32ede3b","633":"909cc36c","666":"78bf1084","686":"67130741","732":"ffccdef7","794":"ec481b53","805":"b888b347","847":"98173376","977":"6c4230d9"}[chunkId] + ".chunk.js";
};